import { createContext } from 'react'

import { type getGetBrokersTaskWorkflowsQueryKey } from 'utils/web_api'

export type WorkflowsContextType = {
  getWorkflowsQueryKey: ReturnType<typeof getGetBrokersTaskWorkflowsQueryKey>
}

const WorkflowsContext = createContext<WorkflowsContextType>({
  getWorkflowsQueryKey: [] as unknown as ReturnType<typeof getGetBrokersTaskWorkflowsQueryKey>,
})

export default WorkflowsContext
